<template>
    <modal
        v-if="show"
        :form="form"
        size="is-small"
        type="is-primary"
        title="Add Funds"
        class="has-selectize"
        submit-text="Add Funds"
        success-text="Funds Added"
        @submit="addFunds"
        @closed="closed"
    >
        <div class="content">
            <div v-if="form.errors.has('form')" class="message is-warning">
                <div class="message-body">
                    {{ form.errors.get('form') }}
                </div>
            </div>

            <p>
                Funds are used to send and receive messages. Add funds to your organization's
                account now!
            </p>

            <form-dropdown
                id="dropdown-amount"
                v-model="form.amount"
                label="Select amount to add"
                placeholder="Select Amount"
                :error="form.errors.get('amount')"
                :settings="{ maxItems: 1 }"
            >
                <option value="2500">$25</option>
                <option value="5000">$50</option>
                <option value="7500">$75</option>
                <option value="10000">$100</option>
            </form-dropdown>

            <form-dropdown
                id="dropdown-source"
                v-model="form.source"
                label="Using This Payment Method"
                placeholder="Select Payment Method"
                :error="form.errors.get('source')"
                :settings="cardDropdownSettings"
            />
        </div>
    </modal>
</template>

<script>
import Form from 'core/Form';
import cardsMixin from 'mixins/cards';

export default {
    emits: ['closed'],
    
    mixins: [cardsMixin],

    props: {
        show: { type: Boolean, required: true },
    },

    data: () => ({
        form: new Form(
            {
                amount: 0,
                source: '',
            },
            false
        ),
    }),

    methods: {
        closed() {
            this.$emit('closed');

            this.form.reset();
        },

        addFunds() {
            const params = {
                quantity: this.form.amount,
            };

            this.form.busy = true;
            this.$store
                .dispatch('updateBillingCreditsMicroservice', params)
                .then(() => {
                    this.form.successful = true;
                    setTimeout(() => {
                        this.closed();
                    }, 1500);
                })
                .catch((errors) => {
                    this.form.errors.record({ quantity: [errors.response.data.quantity] });
                    if (errors.response.data.card_error) {
                        this.form.errors.record({ card_error: [errors.response.data.card_error] });
                    } else if (errors.response.status !== 422) {
                        this.form.errors.record({
                            form: ['Something went wrong, please try again.'],
                        });
                    }
                })
                .finally(() => {
                    this.form.busy = false;
                });
        },
    },
};
</script>
